function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Balance-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "1440px---Balance-home---Stroom",
  transform: "translate(-320.000000, -1027.000000)",
  stroke: "#D3D3D3",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "information-circle",
  transform: "translate(321.000000, 1028.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.90625,10.3125 L8.4375,10.3125 C7.91973305,10.3125 7.5,9.89276695 7.5,9.375 L7.5,7.03125 C7.5,6.77236652 7.29013348,6.5625 7.03125,6.5625 L6.5625,6.5625",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.265625,4.21875 C7.13618326,4.21875 7.03125,4.32368326 7.03125,4.453125 C7.03125,4.58256674 7.13618326,4.6875 7.265625,4.6875 C7.39506674,4.6875 7.5,4.58256674 7.5,4.453125 C7.5,4.32368326 7.39506674,4.21875 7.265625,4.21875 L7.265625,4.21875",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 7.5,
  cy: 7.5,
  r: 7.03125
}))));
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "information-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.2301c9924220ed0b2aec93c8918e5555.svg";
export { ForwardRef as ReactComponent };